module.exports = __webpack_public_path__ + "img/1586708034.a57270cf.jpg";